
import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from './components/BottomTabbar.vue';
import { getBaseInfo } from './api';

const baseUrl = '20251031YUCHAO';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: 'IP形象',
      path: `/${baseUrl}/home`,
      id: 1,
    },
    {
      title: '微短剧',
      path: `/${baseUrl}/emoji`,
      id: 2,
    },
    {
      title: '主题曲',
      path: `/${baseUrl}/music`,
      id: 3,
    },
    {
      title: '新闻报道',
      path: `/${baseUrl}/news`,
      id: 4,
    },
  ];
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '渝超传情——探寻巴渝体育文化新韵',
      url: location.href,
      subtitle: `巴渝体育文化与城市精神同频共振`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '渝超传情——探寻巴渝体育文化新韵',
        subtitle: `巴渝体育文化与城市精神同频共振`,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
  get showFooter() {
    return this.$route.meta && this.$route.meta.showFooter;
  }
}
